import * as React from 'react';
import 'date-fns';
import {connect} from "react-redux";
import {ApplicationState} from "../../store";
import {
	TextField,
	Button,
	FormControl,
	InputLabel,
	MenuItem,
	Select,
	Paper,
	IconButton,
	FormHelperText
} from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save"
import DeleteIcon from '@material-ui/icons/Delete';
import BaseTab, {BaseTabProps, BaseTabState} from "../BaseTab";
import {actionPaymentDelete, actionPaymentFetch, actionPaymentSave} from "../../store/payments/actions";
import {Role} from "../../models/Role";
import FileUploader from "../../core/components/FileUploader";
import {Utility} from "../../core/Utility";
import {actionActiveTabTitle, actionDeleteTab, actionSetTabState} from "../../store/tabs/actions";
import {DeleteConfirmation} from "../components/DeleteConfirmation";
import DateFnsUtils from '@date-io/date-fns';
import {Tab} from "../Tab";
import {Validator} from "../../core/Validator";
import {PaymentDescriptor} from "../../models/Payment";
import {PopupDialog} from "../../core/components/PopupDialog";
import {actionCustomerFetchAll} from "../../store/customers";
import {Customer} from "../../models/Customer";
import {Invoice} from '../../models/Invoice';
import {actionInvoiceFetchAll} from '../../store/invoices/actions';
import {MuiPickersUtilsProvider, KeyboardDatePicker} from '@material-ui/pickers';
import {t} from "../../core/localization";
import {hr} from 'date-fns/esm/locale';
import Autocomplete from "@material-ui/lab/Autocomplete";

export interface PaymentTabProps extends BaseTabProps{
	roles: Role[]
	tab: Tab
	customers: Customer[]
	invoices: Invoice[]
}

export interface PaymentTabState extends BaseTabState{
	isDeleteConfirmationDialogOpen: boolean;
	isDialogOpen: boolean,
	dialogTitle: string,
	dialogText: string,
	validation: any
}

function mapStateToProps(state: ApplicationState) {
	return {
		state: state.tabs.active.state,
		item: state.tabs.active.item,
		roles: state.roles.list,
		tab: state.tabs.active,
		customers: state.customers.list,
		invoices: state.invoices.list
	};
}

class PaymentTab extends BaseTab<PaymentTabProps, PaymentTabState> {

	constructor(props: PaymentTabProps) {
		super(props)
		this.state = {isDeleteConfirmationDialogOpen: false, isDialogOpen: false, dialogText: '', dialogTitle: '', validation: { valid: true, fields: [] }}
	}

	componentWillMount() {
	}

	componentWillReceiveProps(nextProps: PaymentTabProps) {
	}

	componentDidMount() {
		actionInvoiceFetchAll()
		actionCustomerFetchAll()
		if (this.props.item.id) actionPaymentFetch(this.props.item)
	}

	// handleCustomerSelectChange(e: ChangeEvent<{ name?: string; value: unknown }>, name: string) {
	// 	super.handleItemSelectChange(e, name);
	// 	//TODO filter source for invoices
	// }

	render(): React.ReactNode {
		return (
			<div style={{padding: '10px'}}>
				{this.renderTabControls()}
				<div style={{display:'flex', flexDirection:'row', flex:'2', marginTop: '10px' }}>
					<div style={{flex:'1', marginRight: '20px'}}>
						<Paper style={{padding:'10px'}}>
							{this.renderForm()}
							{this.renderFormControls()}
						</Paper>
					</div>
					<div style={{flex:'1'}}>
						<Paper style={{padding:'10px'}}>
							{this.props.item.id && <FileUploader
								itemId={this.props.item.id}
								itemType={'Payments'}
								uploads={this.props.item.uploads}
								onUpload={this.onUpload.bind(this)}
								onDelete={this.onFileDelete.bind(this)}/>}
							{!this.props.item.id && <p style={{textAlign: 'center'}}>{t.SaveItem}</p>}
						</Paper>
					</div>
				</div>
				{this.renderDeleteConfirmationDialog()}
				{this.renderPopupDialog()}
			</div>
		);
	}

	renderForm(): React.ReactNode {

		let invoices: Invoice[] = [];
		let selectedCustomer: Customer[] = [];
		let customerId = this.getItemFromTabState('customerId')
		if(!Utility.isNullOrUndefined(customerId)) {
			invoices = this.props.invoices.filter(x => x.customerId === customerId)
			selectedCustomer = this.props.customers.filter(x => x.id === customerId)
		}

		return <form className='ev-form' noValidate autoComplete="on">
				{/*<FormControl required style={{width: '100%'}} >*/}
				{/*	<InputLabel htmlFor="age-required">{t.Customer}</InputLabel>*/}
				{/*	<Select*/}
				{/*		value={Utility.formatString(this.getItemFromTabState('customerId'))}*/}
				{/*		onChange={(e) => {this.handleItemSelectChange(e, 'customerId')}}*/}
				{/*		name="customerId"*/}
				{/*		required={true}*/}
				{/*		error={Validator.displayFormErrors(this.state.validation.fields, 'customerId').show}*/}
				{/*		style={{width: '100%'}}>*/}
				{/*		{this.props.customers.map((component, key) => (*/}
				{/*			<MenuItem key={key} value={component.id}>{component.title}</MenuItem>*/}
				{/*		))}*/}
				{/*	</Select>*/}
				{/*	<FormHelperText style={{color: '#ed1a3a'}}>{Validator.displayFormErrors(this.state.validation.fields, 'customerId').message}</FormHelperText>*/}
				{/*</FormControl>*/}
				<FormControl required style={{width: '100%'}} >
					<Autocomplete
						options={this.props.customers.sort(Utility.compareForSorting('title'))}
						getOptionLabel={(option: any) => option.title}
						getOptionSelected={(option, value) => option.id === value.id}
						style={{ width: '100%' }}
						value={selectedCustomer[0]}
						onChange={(e: object, value: any | null) => this.handleCustomersAutocompleteChange(value, 'customerId')}
						renderInput={(params) => <TextField {...params} label={t.Customer} margin="normal" required={true} />}
					/>
					<FormHelperText>{Validator.displayFormErrors(this.state.validation.fields, 'customerId').message}</FormHelperText>
				</FormControl>
				<FormControl required style={{width: '100%'}} disabled={Utility.isNullOrUndefined(customerId)} >
					<InputLabel htmlFor="age-required">{t.Invoice}</InputLabel>
					<Select
						value={Utility.formatString(this.getItemFromTabState('invoiceId'))}
						onChange={(e) => {this.onInvoiceChange(e)}}
						name="invoiceId"
						required={true}
						error={Validator.displayFormErrors(this.state.validation.fields, 'invoiceId').show}
						style={{width: '100%'}}>
						{invoices.map((component, key) => (
							<MenuItem key={key} value={component.id}>{component.number}</MenuItem>
						))}
					</Select>
					<FormHelperText style={{color: '#ed1a3a'}}>{Validator.displayFormErrors(this.state.validation.fields, 'invoiceId').message}</FormHelperText>
				</FormControl>
				<TextField
					label={t.Description}
					value={Utility.formatString(this.getItemFromTabState('description'))}
					onChange={(e) => {this.handleItemTextInputChange(e, 'description')}}
					margin="normal"
					fullWidth
					required={true}
					error={!Validator.validate(this.getItemFromTabState('description'), PaymentDescriptor.description.validation)}
				/>
				<TextField
					label={t.PriceAmount}
					value={Utility.formatString(this.getItemFromTabState('price'))}
					onChange={(e) => {this.handleItemTextInputChange(e, 'price')}}
					margin="normal"
					fullWidth
					required={true}
					error={Validator.displayFormErrors(this.state.validation.fields, 'price').show}
					helperText={Validator.displayFormErrors(this.state.validation.fields, 'price').message}
				/>
				<MuiPickersUtilsProvider utils={DateFnsUtils} locale={hr}>
					<KeyboardDatePicker
						margin="normal"
						id="date-picker-dialog"
						label={t.Date}
						format={Utility.PICKER_DATE_FORMAT}
						value={Utility.formatDateString(this.getItemFromTabState('paymentDate'))}
						onChange={(date: Date | null) => {this.handleItemDateChange(date, 'paymentDate')}}
						onBlur={null}
						onFocus={null}
						required={true}
						error={Validator.displayFormErrors(this.state.validation.fields, 'paymentDate').show}
						KeyboardButtonProps={{
							'aria-label': 'change paymentDate',
						}}
						style={{marginRight: '10px'}}
					/>
					<FormHelperText style={{color: '#ed1a3a'}}>{Validator.displayFormErrors(this.state.validation.fields, 'paymentDate').message}</FormHelperText>
				</MuiPickersUtilsProvider>
		</form>;
	}

	renderFormControls(): React.ReactNode {
		return <div style={{display: 'flex', flexDirection:'row-reverse', marginTop: '10px'}}>
				<Button onClick={this.onSaveClick.bind(this)} variant="contained" color="primary" style={{}}><SaveIcon />{t.Save}</Button>
			</div>
	}

	renderTabControls(): React.ReactNode {
		return <div style={{display: 'flex', flexDirection:'row-reverse'}}>
			<IconButton
				aria-label="more"
				aria-controls="long-menu"
				aria-haspopup="true"
				onClick={this.openDeleteConfirmationModal.bind(this)}>
				<DeleteIcon />
			</IconButton>
		</div>
	}

	renderDeleteConfirmationDialog(): React.ReactNode {
		return <DeleteConfirmation
			isOpen={this.state.isDeleteConfirmationDialogOpen}
			onDeleteConfirm={() => this.onDeleteConfirmClick()}
			onToggleModal={() => this.onToggleDeleteConfirmationModal()}
		/>
	}

	renderPopupDialog(): React.ReactNode {
		return <PopupDialog
			isOpen={this.state.isDialogOpen}
			title={this.state.dialogTitle}
			text={this.state.dialogText}
			onClose={this.onDialogClose.bind(this)}
		/>
	}

	onSaveClick () {
		let itemToSave = this.getItemFromTabState()
		let validation: any = Validator.validateItemWithErrorTypes(itemToSave, PaymentDescriptor)

		if(validation.valid) {

			actionPaymentSave(itemToSave)
			actionActiveTabTitle(t.Payment + ' ' + this.getItemFromTabState('description'))
		}

		this.setState({ ...this.state, validation })
	}

	onUpload () {
		actionPaymentFetch(this.props.item)
	}

	onFileDelete () {
		actionPaymentFetch(this.props.item)
	}

	openDeleteConfirmationModal() {
		this.setState({ ...this.state, isDeleteConfirmationDialogOpen: true});
	}

	onToggleDeleteConfirmationModal(){
		this.setState({ ...this.state, isDeleteConfirmationDialogOpen: !this.state.isDeleteConfirmationDialogOpen});
	}

	onDeleteConfirmClick(){
		actionPaymentDelete(this.props.item)
		actionDeleteTab(this.props.tab)
	}

	onDialogClose () {
		this.setState({ ...this.state, isDialogOpen: false})
	}

	onInvoiceChange (e: any) {
		let item: any = this.props.item
		let tabState = this.props.state
		if (!tabState['item']) tabState['item'] = Utility.clone(item)
		let invoice = this.props.invoices.find(x => x.id == e.target.value)
		tabState['item']['invoiceId'] = e.target.value
		tabState['item']['price'] = invoice.price
		actionSetTabState(tabState)
		// this.handleItemSelectChange(e, 'invoiceId')
	}

	protected handleCustomersAutocompleteChange(value: any, name: string) {

		if(value && value.id) {

			let selectedCustomerId = value.id;
			let item: any = this.props.item;
			let tabState = this.props.state;
			if (!tabState['item']) tabState['item'] = Utility.clone(item);
			tabState['item']['contractId'] = '';
			tabState['item']['customerId'] = selectedCustomerId;

			// change tab state
			actionSetTabState(tabState);
		}
	}
}

export default connect(mapStateToProps)(PaymentTab);
